import { reactive } from 'vue';

export const store = reactive({
  tpNF: 1,
  currentTab: 0,
  formData: null,
});
